export const getRealtimeSessionId = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return '';

  const prefix = 'clikkle-rt-session=';
  const entry = document.cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));

  if (entry) {
    try {
      return decodeURIComponent(entry.slice(prefix.length)).slice(0, 128);
    } catch (_) {
      // Ignore malformed cookie values and issue a fresh session id below.
    }
  }

  const cryptoApi = window.crypto;
  const value = cryptoApi && typeof cryptoApi.randomUUID === 'function'
    ? cryptoApi.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

  const hostname = window.location.hostname;
  if (hostname === 'clikkle.com' || hostname.endsWith('.clikkle.com')) {
    document.cookie = `clikkle-rt-session=${encodeURIComponent(value)};path=/;domain=.clikkle.com;SameSite=Lax;Secure`;
  }

  return value.slice(0, 128);
};
